export const LOT_STATUS_COLOR = {
  active:      'success',
  expired:     'error',
  recalled:    'warning',
  quarantined: 'warning',
};

export const LOT_STATUSES = ['active', 'expired', 'recalled', 'quarantined'];
